import React from 'react';
import PropTypes from 'prop-types';
import Stepper from '../../../../Stepper';
import './styles.scss';

const ExchangeProgress = ({
  activeStepIndex,
  disableProceedToNextStep,
  onNextStep,
  onPrevStep,
  onFinish,
  hasCartError,
  hasPaymentError,
}) => {
  const steps = [
    {
      stepName: I18n.t('components.flight.exchange.stepper.title.choose_new_flights'),
      stepIconType: 'aeroplane',
    },
    {
      stepName: I18n.t('components.flight.exchange.stepper.title.cart'),
      stepIconType: 'shoppingCart',
    },
    {
      stepName: I18n.t('components.flight.exchange.stepper.title.payments'),
      stepIconType: 'paymentMethod',
    },
    {
      stepName: I18n.t('components.flight.exchange.stepper.title.confirm_change'),
      stepIconType: 'book',
    },
  ];

  const getStepErrors = () => {
    const stepSequence = ['search', 'cart', 'payment', 'booking'];

    if (!hasCartError && !hasPaymentError) return {};

    return { [activeStepIndex]: stepSequence[activeStepIndex] };
  };

  return (
    <Stepper
      className="exchange-progress"
      steps={steps}
      activeStepIndex={activeStepIndex}
      disableMoveForward={disableProceedToNextStep}
      disableMoveBackward={activeStepIndex === 0}
      showActionButtons={true}
      showStepTitle={true}
      showFinishButton={true}
      finishButtonLabel={I18n.t('components.flight.exchange.stepper.action.confirm')}
      nextButtonLabel={I18n.t('components.ibe.check_out_progress.buttons.next_step')}
      previousButtonLabel={I18n.t('components.ibe.check_out_progress.buttons.previous_step')}
      onFinish={onFinish}
      onMoveNext={onNextStep}
      onMoveBack={onPrevStep}
      nextButtonType="primary"
      errors={getStepErrors()}
    />
  );
};

ExchangeProgress.defaultProps = {
  disableProceedToNextStep: true,
  onNextStep: () => {},
  onFinish: () => {},
  onPrevStep: () => {},
  hasCartError: false,
  hasPaymentError: false,
};

ExchangeProgress.propTypes = {
  activeStepIndex: PropTypes.number.isRequired,
  disableProceedToNextStep: PropTypes.bool,
  onNextStep: PropTypes.func,
  onFinish: PropTypes.func,
  onPrevStep: PropTypes.func,
  hasCartError: PropTypes.bool,
  hasPaymentError: PropTypes.bool,
};

export default ExchangeProgress;
